module.exports = __webpack_public_path__ + "static/media/ebi_hot.9441db1c.webp";